export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/Retail/theme/components/scorecard/MetricsLabels/index.js